import { PatientDocument } from "services/types/patient-documents.type";
import { getFullName } from "./common";

export const formatPatientDocument = (patientDocument: PatientDocument) => {
  return {
    ...patientDocument,
    created_by: {
      ...patientDocument.created_by,
      fullName: getFullName({
        firstName: patientDocument.created_by.first_name,
        lastName: patientDocument.created_by.last_name,
        title: patientDocument.created_by.title,
        suffix: patientDocument.created_by.suffix,
      }),
    },
    updated_by: {
      ...patientDocument.updated_by,
      fullName: getFullName({
        firstName: patientDocument.updated_by.first_name,
        lastName: patientDocument.updated_by.last_name,
        title: patientDocument.updated_by.title,
        suffix: patientDocument.updated_by.suffix,
      }),
    },
  } as PatientDocument;
};
